// removed by extract-text-webpack-plugin
module.exports = {"sorterGroup":"_3dFpbiQEU992kM75na1vL"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Playlists/components/PlaylistsFilterButtons/PlaylistsFilterButtons.scss
// module id = 1362
// module chunks = 1